export function handleLocaleUrl(router) {
  if (router && router?.asPath?.indexOf('#state=') !== -1) {
    return '/';
  }
  return (router && router?.asPath) || '';
}
